import { useSelector } from 'react-redux'
import Card from '../../components/common/Card'
import classes from './SearchResults.module.css'
import SearchBoxItem from './SearchBoxItem'

const SEARCH_SCOPE_MESSAGES = {
    active: 'Showing active patients',
    archived_fallback: 'No active patients found. Showing archived patients.',
    archived_manual: 'Including archived patients',
    empty: 'No patients found (including archived)',
}

const SearchResults = ({ searchedText, searchScope, hideResults, onPanelMouseDown }) => {
    const searchResults = useSelector(state => state.search.results)
    const hasResults = Array.isArray(searchResults) && searchResults.length > 0
    const statusMessage = searchScope ? SEARCH_SCOPE_MESSAGES[searchScope] : null
    const showPanel = hasResults || searchScope === 'empty'

    if (!showPanel) {
        return null
    }

    return (
        <div className={classes.search_results} onMouseDown={onPanelMouseDown}>
            <Card>
                {statusMessage && (
                    <div
                        className={`${classes.search_status} ${searchScope === 'archived_fallback' ? classes.search_status_archived : ''} ${searchScope === 'empty' ? classes.search_status_empty : ''}`}
                    >
                        {statusMessage}
                    </div>
                )}
                {hasResults ? (
                    <ul>
                        {searchResults.map(patient => (
                            <SearchBoxItem
                                key={patient.id}
                                data={patient}
                                searchedText={searchedText}
                                hideResults={hideResults}
                            />
                        ))}
                    </ul>
                ) : null}
            </Card>
        </div>
    )
}

export default SearchResults
